import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M2 10.711V3.682C2 2.75 2.74 2 3.664 2H20.25c.912 0 1.664.749 1.664 1.682V20.23c0 .922-.741 1.683-1.664 1.683h-7.113"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M9.158 21.9H3.265A1.277 1.277 0 0 1 2 20.621v-5.946c0-.703.57-1.279 1.265-1.279h5.893c.695 0 1.265.576 1.265 1.28v5.945a1.27 1.27 0 0 1-1.265 1.28M18.243 5.676l-5.722 5.83M14.515 5.664h3.739V9.33"
    />
  </svg>
);
export const ScaleScreenIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
